// @flow

import _ from 'lodash';

import ReduceStore from 'PMT/flux/ReduceStore';

import {
  Events,
  ActionTypes,
  Constants
} from 'constants';

// -- entity
import ApiError from 'PMT/entities/ApiError';

import {
  ProRole
} from 'PMT/entities/security';

class SecurityStore extends ReduceStore {

  getInitialState() {
    return {
      /**
       * @type ApiError
       */
      apiError: null,

      /**
       * @type ProRole
       */
      elevationProRole: null,

      /**
       * @type string
       */
      elevationCode: null,
    }
  }

  isEmitingCustomEvents(): boolean {
    return true;
  }

  getStateObjectsMap() {
    return {
      apiError: new ApiError(),
      elevationProRole: new ProRole(),
    }
  }

  getApiError(): ApiError {
    return this._state.apiError;
  }

  getElevationProRole(): ProRole {
    return this._state.elevationProRole;
  }

  getElevationCode(): string {
    return this._state.elevationCode;
  }

  reduce(state, action, nextState) {
    switch (action.type) {

      case ActionTypes.LOGOUT:
      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
        return this.getInitialState();

      case ActionTypes.PRO_ROLE_WITH_ELEVATION_CODE_SUCCESS:
        nextState.elevationProRole = action.proRole;
        nextState.elevationCode = action.elevationCode;
        nextState.apiError = null;

        this.emitEvent(Events.ON_PRO_ROLE_WITH_ELEVATION_CODE_SUCCESS);
        return nextState;

      case ActionTypes.PRO_ROLE_WITH_ELEVATION_CODE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_PRO_ROLE_WITH_ELEVATION_CODE_FAILURE);
        return nextState;

      default:
        return nextState;
    }
  }
}

export default new SecurityStore();
